import axios from "axios";

class Axios {
  /**
   * este metodo se encarga de hacer la peticion a la api
   * para obtener todos los maestros registrados en el sistema
   * @return {Promise}
   */
  static async getMasters(route) {
    return await axios.get("auth/" + route);
  }

  /**
   * este metodo se encarga de hacer la peticion a la api
   * para obtener datos del backend con parametros por http
   * @param  {JSON}
   * @return {Promise}
   */
  static async postMasters(data) {
    return await axios.post("auth/" + data.route, data);
  }

  /**
   * este metodo se encarga de hacer la peticion a la api
   * para almacenar un modulo nuevo en la base de datos
   * @param  {JSON}
   * @return {Promise}
   */
  static async saveMaster(data) {
    return await axios.post("auth/" + data.route, data);
  }

  /**
   * este metodo se encarga de hacer la peticion a la api
   * para actualizar un modulo existente en la base de datos
   * @param  {JSON}
   * @return {Promise}
   */
  static async updateMaster(data) {
    return await axios.put("auth/" + data.route + "/" + data.id, data);
  }

  /**
   * este metodo se encarga de hacer la peticion a la api
   * para eliminar un modulo existente en la base de datos
   * @param  {JSON}
   * @return {Promise}
   */
  static async destroyMaster(data) {
    return await axios.delete("auth/" + data.route + "/" + data.id);
  }

  /**
   * este metodo se encarga de hacer la peticion a la api
   * para subir un archivo
   * @param  {JSON}
   * @return {Promise}
   */
  static async uploadMaster(route, data, config) {
    return await axios.post(route, data, config)
  }
}

export { Axios };
